// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__QNddS","link":"HeaderSimple_link__7T7Re","inputSearch":"HeaderSimple_inputSearch__56u4v"};